import * as React from "react";
const SvgComponent = (props) => (
  <svg width="0.8em" height="1em" fill="none" viewBox="0 0 24 24" {...props}>
    <path
      fill="currentColor"
      d="m20.073 2 1.415 1.414-5.85 5.85h2.544v2h-6v-6h2v2.627L20.073 2zm-8.891 10.264v6h-2v-2.422L3.414 21.61 2 20.196l5.932-5.932h-2.75v-2h6z"
    />
  </svg>
);
export { SvgComponent as IconWindowMinimize3 };
